<script>
import { hmdaMethods, toasterMethods } from '@state/helpers'
import constant from '@constants/constant'

export default {
  data() {
    return {
      excludeErrors: false,
      options: [25, 50, 75, 100],
      fields: [
        {
          key: 'customselect',
          label: 'Select',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'creationDate',
          label: 'Date',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'refItem',
          label: 'Project Name',
          refValField: 'projectName',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'minActionDate',
          label: 'Min Action Date',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'maxActionDate',
          label: 'Max Action Date',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'failedCount',
          label: 'Failed Count',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'passedCount',
          label: 'Passed Count',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'szStatus',
          label: 'Status',
          sortable: false,
          class: 'text-left',
        },
      ],
      projectsList: [],
      statusCompleted: constant.hmdaProjectStatus.completed.value,
      currentFilter: constant.hmdaProjectStatus.new.value,
      rows: 0,
      perPage: 25,
      currentPage: 1,
      searchDrop: 'ProjectName',
      filterTable: '',
      isDefault: true,
      isOpen: false,
      commands: [
        {
          choices: [
            constant.hmdaProjectStatus.all,
            constant.hmdaProjectStatus.new,
            constant.hmdaProjectStatus.inProgress,
            constant.hmdaProjectStatus.completed,
          ],
          event: 'filter',
          selected: constant.hmdaProjectStatus.all.value,
          isChoice: true,
        },
        {
          text: 'Generate LAR File',
          event: 'lar-download',
          requiresSelect: true,
          selectFn: (rows) => {
            // returns isDisabled value
            return !(
              rows.some((i) => i.status === this.statusCompleted) &&
              !rows.some((i) => i.status !== this.statusCompleted)
            )
          },
          tooltip: 'Request for pipe separated LAR files',
        },
      ],
      optionsusers: {
        'Project Name': 'ProjectName',
      },
      headeTitle: 'Projects',
      showSpinner: false,
      searchSelected: {
        selectedOption: '',
        search: '',
      },
      messageType: '',
      showModalAlert: false,
      alertMessage: '',
      customer: null,
      user: null,
      quarter: '',
      quarters: [
        { text: 1, value: 1 },
        { text: 2, value: 2 },
        { text: 3, value: 3 },
        { text: 4, value: 4 },
      ],
      year: null,
      // projectErrors: [],
      showLarGenerationModal: false,
      showLARErrors: false,
      // filingYearError: null,
      customErrors: [],
      fieldErrors: [],
      customError1: 'Year of filing not matching with Year in Action date',
      customError2: 'Duplicate ULIs are found',
    }
  },

  async mounted() {
    await this.getSelectedCustomer().then((res) => {
      this.customer = res
    })

    await this.getSelectedUser().then((res) => {
      this.user = res
    })

    this.commands[0].choices = this.commands[0].choices.map((f) => {
      return { text: `Filter: ${f.text}`, value: f.value }
    })

    this.searchSelected = {
      selectedOption: 'All',
      search: '',
    }
    this.getTotalProjects(this.searchSelected)

    this.getSelectedCustomer().then((res) => {
      this.customer = res
    })

    this.getSelectedUser().then((res) => {
      this.user = res
    })
  },

  methods: {
    ...hmdaMethods,
    ...toasterMethods,
    onCommandEvent(command, val) {
      switch (command) {
        case 'lar-download':
          this.showLarGenerationModal = true
          // this.$refs.msg
          //   .showAsync(null, 'LAR Generation', 'Submit Request')
          //   .then((o) => {
          //     this.showSpinner = true

          //     this.generateLAR({
          //       isErrorRowsExcluded: !this.excludeErrors,
          //       projectIds: this.$refs.refProjects
          //         .getSelectedRecords()
          //         .map((r) => r.projectId),
          //       customerId: this.customer ? this.customer.value : 0,
          //       userId: this.user ? this.user.value : 0,
          //       larYear: Number(this.year),
          //       larQuarter: Number(this.quarter),
          //     })
          //       .then((r) => {
          //         this.$refs.genmsg
          //           .showAsync(
          //             'LAR file request is submitted successfully.',
          //             //  A download link will be emailed to you once the file is ready for download',
          //             'Confirmation',
          //             'Go To LAR Summary Page',
          //             'Close'
          //           )
          //           .then((ok) => {
          //             this.$router.push({
          //               name: 'hmda-lars',
          //             })
          //           })
          //       })
          //       .finally(() => {
          //         this.showSpinner = false
          //       })
          //   })
          //   .catch((e) => {})
          break
        case 'filter':
          this.filterByStatus(val)
          break
      }
    },
    filterByStatus(status) {
      this.searchSelected = {
        selectedOption: status ? 'status' : 'All',
        search: status || '',
      }
      this.currentPage = 1
      this.getProjects(this.searchSelected)
    },
    toStatusString(val) {
      return constant.hmdaStatusMap[val] || ''
    },

    getTotalProjects(selectedvalue) {
      this.getProjects(selectedvalue)
    },

    getProjects(selectedvalue) {
      this.showSpinner = true
      return this.fetchProjectsList({
        PageSize: this.perPage,
        PageNumber: this.currentPage,
        SearchKey: selectedvalue.selectedOption,
        SearchValue: selectedvalue.search,
        customerId: this.customer ? this.customer.value : 0,
      })
        .then((response) => {
          let projectsList = response ? response.data.projects || [] : []
          projectsList.forEach((project) => {
            project.szStatus = this.toStatusString(project.status)
          })
          this.projectsList = projectsList
          this.rows = response.data.totalProjectsCount
          this.currentPage = this.currentPage
          this.showSpinner = false
        })
        .catch((error) => {
          this.showSpinner = false
          this.showModalAlert = true
          this.autherror = error
          this.messageType = constant.imageHeaderError
          this.alertMessage = constant.errorMessage
        })
    },

    onClickRefItem(row) {
      this.gotoProjectDetails(row)
    },
    onRowSelection(row, rows) {
      // console.log(row)
    },

    gotoProjectDetails(item) {
      this.$router.push({
        name: 'hmda-project-details',
        params: { id: item.projectId },
      })
    },

    confirmClicked() {
      this.showModalAlert = false
    },

    paginationEvent(currentPage) {
      if (this.currentPage !== currentPage) {
        this.showSpinner = true
        this.currentPage = currentPage
        this.getProjects(this.searchSelected)
      }
    },

    rowPerPageCount(pageValue) {
      this.perPage = parseInt(pageValue)
      this.currentPage = 1
      if (this.rows !== 0) {
        this.showSpinner = true
        this.getProjects(this.searchSelected)
      }
    },

    showSearchMenu() {
      this.isOpen = !this.isOpen
    },

    closeButton() {
      this.isDefault = true
      this.isOpen = false
    },

    onUserSearchSubmit(selectedvalue) {
      this.showSpinner = true
      this.currentPage = 1
      this.getTotalProjects(selectedvalue)
      this.searchSelected = selectedvalue
    },
    closeLARGenModal() {
      this.showLarGenerationModal = false
      this.showLARErrors = false
      this.year = null
      this.quarter = ''
      this.excludeErrors = false
      // this.projectErrors = []
      // this.filingYearError = null
      this.customErrors = []
      this.fieldErrors = []
    },
    generateLARSummary() {
      this.showLARErrors = false
      this.customErrors = []
      this.fieldErrors = []
      this.$validator.validate().then((response) => {
        if (response) {
          this.showSpinner = true
          this.generateLAR({
            isErrorRowsExcluded: !this.excludeErrors,
            projectIds: this.$refs.refProjects.getSelectedRecords().map((r) => r.projectId),
            customerId: this.customer ? this.customer.value : 0,
            userId: this.user ? this.user.value : 0,
            larYear: Number(this.year),
            larQuarter: Number(this.quarter),
          })
            .then((r) => {
              if(r.status === 200) {
                let larErrors = r.data || []
                this.showLARErrors = larErrors.length > 0
                // handling custom and field errors
                if(larErrors.length) {
                  let lErrors = larErrors.filter((e) => (e.includes(this.customError1) || e.includes(this.customError2))) || []
                  if(lErrors.length > 0) {
                    this.customErrors = larErrors
                  } else {
                    this.fieldErrors = larErrors
                  }
                }
                // show modal box and route to LAR summary page.
                if(!this.customErrors.length && !this.fieldErrors.length) {
                  this.showLarGenerationModal = false
                  this.$refs.genmsg
                  .showAsync(
                    'LAR file request is submitted successfully.',
                    //  A download link will be emailed to you once the file is ready for download',
                    'Confirmation',
                    'Go To LAR Summary Page',
                    'Close'
                  )
                  .then((ok) => {
                    this.$router.push({
                      name: 'hmda-lars',
                    })
                  })
                }
              }
            })
            .finally(() => {
              this.showSpinner = false
            })
        }
      })
    },
  },
}
</script>
<template>
  <div>
    <BaseSpinner v-if="showSpinner" />
    <BaseModalLayout ref="genmsg" modal-size="md" />
    <BaseModalLayout
      :show-modal="showLarGenerationModal"
      modal-title="LAR Generation"
      modal-size="md"
      ok-variant="Submit Request"
      cancel-variant="Cancel"
      @confirmOkClicked="generateLARSummary"
      @confirmCancelClicked="closeLARGenModal">
      <BaseSpinner v-if="showSpinner" />
      <b-row class="mb-2 mt-1">
        <b-col md="4">
          <BaseEInputText
            id="year"
            v-model="year"
            v-validate="{
              required: true,
              regex: /^(199[9]|20[0-2][0-9]|20[3-9][0-9]|[2-9][0-9]{3})$/,
            }"
            validattor="[0-9]"
            type="text"
            maxlength="4"
            name="year"
            label-content="Year"
            mark-required
            data-vv-as="Year"
            :class="{
              input: false,
              'is-danger': errors.has('year'),
            }"
            placeholder="xxxx"
          ></BaseEInputText>
          <div class="error"> {{ errors.first('year') }} </div>
        </b-col>
        <b-col md="4">
          <BaseELabel mark-required label="Quarter" size="sm" />
          <BaseDropdown
            v-model="quarter"
            v-validate="{ required: true }"
            :field-id="quarter"
            :options="quarters"
            data-vv-as="Quarter"
            name="quarter"

          ></BaseDropdown>
          <div class="error">
            {{ errors.first('quarter') }}
          </div>
        </b-col>
      </b-row>
      <div class="py-3">
        <p>Please confirm the selection to generate LAR file</p>
        <b-checkbox v-model="excludeErrors" class="d-inline-block w-auto" />
        Include records with errors
      </div>

      <div v-if="showLARErrors">
      <div class="border-bottom mt-3"></div>
      <b-row class="mt-2 mb-1">
        <b-col>
          <BaseELabel label="Error(s):" class="textError"/>
        </b-col>
      </b-row>
      <div v-if="fieldErrors.length">
        <BaseELabel label="Below fields are required and cannot be left blank. Please review and update the data accordingly." class="textError" />
        <div v-for="(error, e) in fieldErrors" :key="e"><BaseELabel :label="`${error}`" class="textError my-0 mx-2" /></div>
      </div>
      <div v-if="customErrors.length">
        <div v-for="(err, er) in customErrors" :key="er"><BaseELabel :label="`${err}`" class="textError" /></div>
      </div>
      <div class="mb-3"></div>
      </div>
    </BaseModalLayout>

    <BaseModalAlert
      :modal-show="showModalAlert"
      :title-header="messageType"
      :alert-message="alertMessage"
      @confirmClicked="confirmClicked"
    ></BaseModalAlert>

    <div>
      <BaseTitleMenu
        v-if="isDefault"
        :heade-title="headeTitle"
        :optionsusers="optionsusers"
        show-search
        @showSearchMenu="showSearchMenu"
      ></BaseTitleMenu>

      <BaseSearch
        v-if="isOpen"
        v-model="searchDrop"
        :optionsusers="optionsusers"
        :show-close-button="true"
        :show-styling="true"
        @closeButton="closeButton"
        @searchSubmit="onUserSearchSubmit"
      />

      <div class="border-bottom my-3" />

      <BaseDataTable
        ref="refProjects"
        :options="options"
        :items="projectsList"
        :fields="fields"
        :commands="commands"
        show-envelope
        show-eye
        showdatatablefooter
        data-table-selectable
        :total-rows="rows"
        :per-page="perPage"
        :current-page="currentPage"
        @rowPerPageChange="rowPerPageCount"
        @paginationEvent="paginationEvent"
        @onClickEditEvent="gotoProjectDetails"
        @onClickRefItem="onClickRefItem"
        @onCommandEvent="onCommandEvent"
      >
      </BaseDataTable>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// .textFont {
//   font-size: $size-content-font-sm;
//   color: $color-status-fail;
// }
.textError {
  color: $color-error-text;
}
</style>
